import type { AssetShareAccess } from 'fym-shared/src/music24/assetShares';
import { SMLRootParamList, SMLRouteNames } from '../../../routing/sml/SMLRoutes';
import { releaseAssetParams } from '../promote/releases/releasePageLink';

/**
 * The place of a shared asset for a member: the Assets tab of its release with the asset viewer
 * open on that revision (`?asset=&rev=`), and the artist of the asset selected (`accountId`). The
 * Assets tab finds a reel by its uuid too.
 */
export function sharedAssetRouteParams(access: AssetShareAccess): SMLRootParamList[SMLRouteNames.promoteRelease] {
  return {
    ...releaseAssetParams(access.catalogItemUuid, access.assetUuid, access.revision),
    accountId: access.accountId,
  };
}

/** The public routes of the web app that show the share banner and the top bar to a visitor. */
export function isPublicShareRouteName(name: string | undefined): boolean {
  return name === SMLRouteNames.public || name === SMLRouteNames.a;
}
